var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M5.003 22h14c1.103 0 2-.897 2-2v-9a1 1 0 0 0-.293-.707l-8-8a1 1 0 0 0-1.414 0l-8 8a1 1 0 0 0-.293.707v9c0 1.103.897 2 2 2m5-2v-5h4v5zm-5-8.586 7-7 7 7V20h-3v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5h-3z"
})));
export default SvgHome;